import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-icon',
  templateUrl: './upload-icon.component.html',
  styleUrls: ['./upload-icon.component.scss']
})
export class UploadIconComponent {

  @Input() stroke = '#0C0C12'

  constructor() { }

  ngOnInit() {
  }

}
